import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Strings from '../Strings';

export default function Pricing() {
  const nav = useNavigate();
  return (
    <section id="pricing" className="relative py-32 overflow-hidden" style={{ background: 'linear-gradient(180deg,#0A0806,#13100A)' }}>
      <Strings density={6} opacity={0.35} />
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <p className="eyebrow mb-4">Pricing</p>
        <h2 className="font-display text-5xl md:text-7xl text-cream leading-[0.95]">Every song is <span className="italic text-gold-grad">quoted to the job.</span></h2>
        <p className="mt-7 text-cream/70 text-lg leading-relaxed">A 15-second jingle for one location is not a full anthem for a regional brand. Tell us what you need. You see your price with your song, and you only pay once you&rsquo;ve heard it.</p>
        <button onClick={() => nav('/start')} className="mt-10 btn-gold rounded-full px-8 py-4 inline-flex items-center gap-2 text-[15px]">
          Start your song <ArrowRight size={18} />
        </button>
      </div>
    </section>
  );
}
